import "./mirotone.css"; // TODO: Change to proper Mirotone link from package instead of from the local file
import "./index.css";

import React from "react";
import ReactDOM from "react-dom";
import { miroApiShim } from "./refractCommon/miro/miroLimiterShim";
import Sidebar from "./sidebar";
import config from "./config"



miroApiShim();

const { board } = window.miro;
const paramDo = new URL(document.location.toString()).searchParams.get("do");

async function init() {
  console.log("power-pack hit init")
  ReactDOM.render(
    <React.StrictMode>Running {config.version}</React.StrictMode>,
    document.getElementById("root")
  );

  const result = board.ui.on("icon:click", async () => {
    await board.ui.openPanel({ url: "index.html?do=sidebar" });
  });


}

async function sidebar() {

  ReactDOM.render(
    <React.StrictMode>
      <>
        <Sidebar />
      </>
    </React.StrictMode>,
    document.getElementById("root")
  );
}

if (paramDo === "sidebar") {
  sidebar();
} else {
  init();
}
